var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("popup", {
        staticClass: "layerGuide solid",
        attrs: {
          opened: _vm.isGuidePopupOpen,
          useHeader: false,
          useFooter: true
        },
        on: {
          "update:opened": function($event) {
            _vm.isGuidePopupOpen = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticClass: "setting" }, [
                  _c("button", { staticClass: "btn icon md normal left" }, [
                    _vm._v(" " + _vm._s(_vm.$t("MMAIN-04-01-02-01")) + " "),
                    _c("i", { staticClass: "icon icon-dropdown-arrow" })
                  ]),
                  _c("button", { staticClass: "btn icon md normal right" }, [
                    _c("i", { staticClass: "icon icon-setting" }),
                    _vm._v(" " + _vm._s(_vm.$t("MMAIN-04-01-02-02")) + " ")
                  ]),
                  _c("div", { staticClass: "guide left" }, [
                    _vm._v(" " + _vm._s(_vm.$t("MMAIN-04-01-02-03")) + " ")
                  ]),
                  _c("div", { staticClass: "guide right" }, [
                    _vm._v(" " + _vm._s(_vm.$t("MMAIN-04-01-02-04")) + " ")
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn md solid",
                    on: {
                      click: function() {
                        _vm.isGuidePopupOpen = false
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("MMAIN-04-01-02-05")) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }